import namedRegExp from 'named-js-regexp'

const start = /^ */
const end = / *$/
const whitespace = / +/

const now = /(now)/

// timestamp pattern, for example '1484524800000'
const timestamp = /(:<timestamp>\d{5,})/

// ISO string pattern, for example '2017-01-16T21:30:00.000Z'
// source: http://stackoverflow.com/a/3143231/1262753
const isoString = /(:<isoString>(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))/

// patterns like:
//     'today'
//     'yesterday'
//     'tomorrow'
export const relativeDay = /(:<relativeDay>today|yesterday|tomorrow)/

// patterns like:
//     'Sunday'
//     'last Sunday'
//     'next Monday'
//     'Tue'
export const weekday = /((:<which>last|next) +)?(:<weekday>Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday|Mon|Tue|Wed|Thu|Fri|Sat|Sun)/

// patterns like:
//     '2017-02-25'
const date = /(:<date>\d{4}-[01]\d-[0-3]\d)/

// patterns like:
//     '08:00'
//     '8:00:00'
// note that '8:00' is not supported because that cannot safely be parsed by momentjs (loses timezone)
const time = /(:<time>[0-2]\d:[0-5]\d(:[0-5]\d)?)/

// patterns like:
//     '08:00'
//     '08:00 PM'
//     '08:00:00 PM'
// note that '8:00' is not supported because that cannot safely be parsed by momentjs (loses timezone)
const americanTime = /(:<americanTime>(:<time>[0-2]\d:[0-5]\d(:[0-5]\d)?)( +(:<period>AM|PM))?)/

// american date
//     '02/25/2017'
//     '02/25/17'
const americanDate = /(:<americanDate>[01]\d\/[0-3]\d\/\d{2}(\d{2})?)/

// russian date
//     '25.02.2017'
//     '25.02.17'
const russianDate = /(:<russianDate>[0-3]\d\.[01]\d\.\d{2}(\d{2})?)/

// patterns like:
//    'America/New_York'
//    'America/New York'
//    'New York'
const timezone = /(:<timezone>[a-zA-Z][a-zA-Z0-9_ /+-]*)/

// make a regexp optional
function optional (regexp) {
  return new RegExp('((' + regexp.source + ')?)', regexp.options)
}

// merge multiple regexps
function merge (...parts) {
  // TODO: merge options of the parts
  return new RegExp(parts.map(p => '(' + p.source + ')').join(''), 'i')
}

export const nowRegExp = namedRegExp(merge(start, now, end))

// weekday like 'Saturday', 'last Monday 09:00'
export const weekdayRegExp = namedRegExp(merge(
    start,
    weekday,
    optional(merge(whitespace, americanTime)),
    optional(merge(whitespace, timezone)),
    end))

// today, tomorrow, yesterday
export const relativeDayRegExp = namedRegExp(merge(
    start,
    relativeDay,
    optional(merge(whitespace, americanTime)),
    optional(merge(whitespace, timezone)),
    end))

// timestamp pattern, for example '1484524800000'
export const timestampRegExp = namedRegExp(merge(start, timestamp, end))

// ISO string pattern, for example '2017-01-16T21:30:00.000Z'
export const isoStringRegExp = namedRegExp(merge(start, isoString, end))

// time pattern
// matched patterns:
//   '07:48:42'
//   '07:48'
//   '07:48 PM'
export const timeRegExp = namedRegExp(merge(
    start,
    americanTime,
    optional(merge(whitespace, timezone)),
    end))

// date time pattern
// matched patterns:
//   '2017-01-14 07:48:42'
//   '2017-01-14 07:48'
//   '2017-01-14'
export const dateTimeRegExp = namedRegExp(merge(
    start,
    date,
    optional(merge(whitespace, americanTime)),
    optional(merge(whitespace, timezone)),
    end))

// american date time
// example: '02/25/2017 01:16:13 PM'
// example: '02/25/2017 01:16 PM'
// example: '02/25/2017'
// example: '02/25/17'
// example: '02/25/2017 Europe/Amsterdam'
export const americanDateTimeRegExp = namedRegExp(merge(
    start,
    americanDate,
    optional(merge(whitespace, americanTime)),
    optional(merge(whitespace, timezone)),
    end))

// russian date time
// example: '25.02.2017 18:16:13'
// example: '25.02.2017 18:16'
// example: '25.02.2017'
// example: '25.02.2017 Europe/Amsterdam'
export const russianDateTimeRegExp = namedRegExp(merge(
    start,
    russianDate,
    optional(merge(whitespace, time)),
    optional(merge(whitespace, timezone)),
    end))



// WEBPACK FOOTER //
// ./src/tttime/regExpRecipes.js